import 'reflect-metadata';
import {JsonProperty} from "json-object-mapper";

export class Session {
  @JsonProperty({name: "space"})
  public space?: String = undefined;

  @JsonProperty({name: "username"})
  public username?: String = undefined;

  @JsonProperty({name: "created"})
  public created?: number = undefined;

  @JsonProperty({name: "first_name"})
  public firstName?: String = undefined;

  @JsonProperty({name: "last_name"})
  public lastName?: String = undefined;

  @JsonProperty({name: "frontends"})
  public frontends: string[] = [];

  @JsonProperty({name: "case_manager"})
  public cases?: String = undefined;
}

class Token {
  protected refresh: string;
  protected xsrf: string;

  constructor(refresh: string, xsrf: string) {
    this.refresh = refresh;
    this.xsrf = xsrf
  }
}
